<template>
    <div class="RiskMannFlechaSubir">
        <transition name="volver-arriba">
            <button v-show="visible && !oculto" id="btn-back-top" type="button"
                class="boton-volver-arriba" aria-label="Volver arriba" title="Volver arriba"
                @click="subir">
                <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 15l7-7 7 7"></path>
                </svg>
            </button>
        </transition>
    </div>
</template>

<script>
// Píxeles de desplazamiento a partir de los que aparece
const UMBRAL_PX = 350;

export default {
    name: "RiskMannFlechaSubir",

    props: {
        // El panel del asistente (AsistenteIA.vue) está abierto y ocupa la esquina
        oculto: { type: Boolean, default: false },
    },

    // Eventos: "cambio-visibilidad" (el asistente sube mientras la flecha está
    // visible) y "subir" (al pulsarla, el gato del asistente salta).

    data() {
        return { visible: false };
    },

    watch: {
        visible(valor) {
            this.$emit("cambio-visibilidad", valor);
        },
    },

    created() {
        this.cuadroPendiente = null;
    },

    mounted() {
        window.addEventListener("scroll", this.alDesplazar, { passive: true });
        this.alDesplazar();
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.alDesplazar);
        if (this.cuadroPendiente) cancelAnimationFrame(this.cuadroPendiente);
    },

    methods: {
        // El evento scroll se dispara muchas veces: se calcula como máximo una vez por cuadro
        alDesplazar() {
            if (this.cuadroPendiente) return;
            this.cuadroPendiente = requestAnimationFrame(() => {
                this.cuadroPendiente = null;
                this.visible = window.scrollY > UMBRAL_PX;
            });
        },

        subir() {
            this.$emit("subir");
            const reducirMovimiento = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            window.scrollTo({ top: 0, behavior: reducirMovimiento ? "auto" : "smooth" });
        },
    },
};
</script>

<style scoped>
/* Mismo lenguaje visual que el botón del asistente (AsistenteIA.vue), centrado
   debajo de él: el asistente mide 64px y está a 45px del borde. Queda a 60px
   del borde inferior para no taparse con el footer fijo. Sube lo que mida una
   barra fija de la página, si la hay (--alto-barra-cambios, ver EditarPerfil.vue). */
.boton-volver-arriba {
    position: fixed;
    right: 55px;
    bottom: calc(60px + var(--alto-barra-cambios, 0px));
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    padding: 0;
    border: 1px solid #e4e8f3;
    border-radius: 50%;
    background-color: #ffffff;
    color: #233976;
    cursor: pointer;
    box-shadow: 0 8px 24px rgba(35, 57, 118, 0.22);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.boton-volver-arriba:hover {
    box-shadow: 0 12px 34px rgba(35, 57, 118, 0.32);
    transform: translateY(-2px);
}

.boton-volver-arriba:focus-visible {
    outline: 2px solid #3a55a3;
    outline-offset: 3px;
}

/* Nunca se encima con el asistente: aparece cuando este ya terminó de subir
   (0.25s en AsistenteIA.vue) y se va antes de que empiece a bajar. */
.volver-arriba-enter-active {
    transition: opacity 0.2s ease 0.25s, transform 0.2s ease 0.25s;
    pointer-events: none;
}

.volver-arriba-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
    pointer-events: none;
}

.volver-arriba-enter,
.volver-arriba-leave-to {
    opacity: 0;
    transform: translateY(8px);
}

@media (prefers-reduced-motion: reduce) {
    .boton-volver-arriba,
    .volver-arriba-enter-active,
    .volver-arriba-leave-active {
        transition: none;
    }

    .boton-volver-arriba:hover {
        transform: none;
    }
}
</style>
